import { themeVars } from '@libs/shared-ui-styles';

export const defaultIconColor = 'currentColor';
export const whiteIconColor = themeVars.color.white;
export const defaultVideoIconColor = themeVars.color.shadow._36;
